import {
  Drawer,
  Grid,
  Box,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Checkbox,
  Typography,
  TextField,
  FormControlLabel,
  Card,
  Button,
  Tabs,
  Tab,
  IconButton,
  CardContent,
  Chip,
  MenuItem,
  Alert,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { TabProps } from '../../utils/tabProps';
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';
import { api_file_url_cmd_fb } from '../../config/Params.constant';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  updateCmdFournisseur,
  viewCmdFournisseur,
} from '../../redux/slices/commande-fournisseur.slice';
import { metaux } from '../../utils/metaux.enum';
import { getPublicListFournisseur } from '../../redux/slices/fournisseur.slice';
import { api_file_url_catalogue } from '../../config/Params.constant';
import DefaultImg from '../../assets/images/backgrounds/img-default.png';
import ImageZoomer from '../../components/image/ImageZoomer';

const CmdFbDetailsWidget = ({ show, onClose, idCmdFournisseur }) => {
  const dispatch = useDispatch();
  const { loading, error } = useSelector((state) => state?.cmd_achat_store);
  const [sel_tab, set_sel_tab] = useState(0);
  const [cmd, set_cmd] = useState(null);
  const [lst_fournisseur, set_lst_fournisseur] = useState([]);

  const handleChange = (event, newValue) => {
    set_sel_tab(newValue);
  };

  const load_data = () => {
    if (idCmdFournisseur)
      dispatch(viewCmdFournisseur(idCmdFournisseur))
        .unwrap()
        .then((res) => {
          set_cmd(res);
        })
        .catch((err) => console.log(err));
  };
  const load_fb = () => {
    dispatch(getPublicListFournisseur())
      .unwrap()
      .then((res) => {
        set_cmd(res);
      })
      .catch((err) => console.log(err));
  };

  const onUpdateCmd = (data) => {
    if (data)
      dispatch(updateCmdFournisseur(data))
        .unwrap()
        .then((res) => {
          load_data();
        })
        .catch((err) => console.log(err));
  };

  useEffect(() => {
    load_data();
  }, [idCmdFournisseur]);

  useEffect(() => {
    load_fb();
  }, []);

  return (
    <Drawer
      anchor={'right'}
      open={show}
      onClose={onClose}
      PaperProps={{
        sx: { width: { xs: '100%', lg: '75%' } },
      }}
    >
      <Box p={3}>
        <Grid container spacing={1}>
          <Grid item xs={12} sx={{ textAlign: 'end' }}>
            <IconButton onClick={onClose}>
              <FeatherIcon icon="x" />
            </IconButton>
          </Grid>

          <Grid item xs={12}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs value={sel_tab} onChange={handleChange} aria-label="basic tabs example">
                <Tab label="Info" {...TabProps(0)} />
                {/* <Tab label="Historiques" {...TabProps(1)} /> */}
                <Tab label={`Blocages (${cmd?.bloquages?.length ?? 0})`} {...TabProps(1)} />
                <Tab label={`Notes (${cmd?.notes?.length ?? 0})`} {...TabProps(2)} />
                {/* <Tab label="Factures" {...TabProps(4)} /> */}
                {/* <Tab label="Tâches rattachées" {...TabProps(3)} /> */}
                <Tab label="Côntrole Qualité" {...TabProps(4)} />
              </Tabs>
            </Box>
            <Grid item xs={12}>
              {sel_tab == '0' && (
                <CmdInfoSection
                  cmd={cmd}
                  onUpdateValues={onUpdateCmd}
                  lst_fournisseur={lst_fournisseur}
                />
              )}
              {/* {sel_tab == "1" && <CmdHistoriqueSection cmd={cmd} />} */}
              {sel_tab == '1' && <CmdBlocageSection cmd={cmd} onUpdateValues={onUpdateCmd} />}
              {sel_tab == '2' && <CmdNoteSection cmd={cmd} onUpdateValues={onUpdateCmd} />}
              {sel_tab == '4' && <ControleQualiteSection cmd={cmd} onUpdateValues={onUpdateCmd} />}
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Drawer>
  );
};

const CmdInfoSection = ({ cmd, onUpdateValues, lst_fournisseur }) => {
  const default_form_urg_values = { date_urgent: null };
  const default_form_liv_values = { date_livraison: null };
  const [show_urg_form, set_show_urg_form] = useState(false);
  const [show_liv_form, set_show_liv_form] = useState(false);
  const [show_fb_form, set_show_fb_form] = useState(false);
  const [form_urg_values, set_form_urg_values] = useState(default_form_urg_values);
  const [form_liv_values, set_form_liv_values] = useState(default_form_liv_values);
  const [form_fb_values, set_form_fb_values] = useState(null);
  const [show_taille_grav_form, set_show_taille_grav_form] = useState(false);
  const [form_taille_grav_values, set_form_taille_grav_values] = useState(null);

  const renderStatus = (status) => {
    switch (status) {
      case 'nouvel':
        return (
          <Chip
            sx={{
              backgroundColor: '#2196F3',
              color: '#fff',
              borderRadius: '3px',
              px: '3px',
            }}
            size="small"
            label={status}
          />
        );

      case 'en-attente':
        return (
          <Chip
            sx={{
              backgroundColor: '#f3ae53',
              color: '#fff',
              borderRadius: '3px',
              px: '3px',
            }}
            size="small"
            label={status}
          />
        );

      case 'en-cours':
        return (
          <Chip
            sx={{
              backgroundColor: '#9761cd',
              color: '#fff',
              borderRadius: '3px',
              px: '3px',
            }}
            size="small"
            label={status}
          />
        );
      case 'envoye-fabricant':
        return (
          <Chip
            sx={{
              backgroundColor: '#00c875',
              color: '#fff',
              borderRadius: '3px',
              px: '3px',
            }}
            size="small"
            label={status}
          />
        );

      default:
        return (
          <Chip
            sx={{
              backgroundColor: '#0484c2',
              color: '#fff',
              borderRadius: '3px',
              px: '3px',
            }}
            size="small"
            label={status}
          />
        );
    }
  };

  const onSetUrgent = () => {
    if (form_urg_values.date_urgent) {
      let tmp = {
        idCmdFournisseur: cmd?.idCmdFournisseur,
        is_urgent: true,
        date_urgent: form_urg_values?.date_urgent,
      };
      onUpdateValues(tmp);
      set_form_urg_values(default_form_urg_values);
      set_show_urg_form(false);
    }
  };

  const onSetFournisseur = () => {
    if (form_fb_values?.idFournisseur) {
      let tmp = {
        idCmdFournisseur: cmd?.idCmdFournisseur,
        fournisseur: { idFournisseur: form_fb_values?.idFournisseur },
      };
      onUpdateValues(tmp);
      set_form_fb_values(null);
      set_show_fb_form(false);
    }
  };

  const onSetNonUrgent = () => {
    let tmp = {
      idCmdFournisseur: cmd?.idCmdFournisseur,
      is_urgent: false,
      date_urgent: null,
    };
    onUpdateValues(tmp);
  };

  const onUpdateDateLivraison = () => {
    if (form_liv_values.date_livraison) {
      let tmp = {
        idCmdFournisseur: cmd?.idCmdFournisseur,
        date_livraison: form_liv_values?.date_livraison,
      };
      onUpdateValues(tmp);
      set_form_liv_values(default_form_liv_values);
      set_show_liv_form(false);
    }
  };

  const onUpdateTailleGravure = () => {
    if (form_taille_grav_values.taille) {
      let tmp = {
        idCmdFournisseur: cmd?.idCmdFournisseur,
        taille: form_taille_grav_values?.taille,
        gravure: form_taille_grav_values?.gravure,
        sku_externe: form_taille_grav_values?.sku_externe,
      };
      onUpdateValues(tmp);
      set_show_taille_grav_form(false);
    }
  };
  
  useEffect(() => {
      set_form_taille_grav_values({ taille: cmd?.taille, gravure: cmd?.gravure, sku_externe: cmd?.sku_externe, });
    }, [cmd]);

  return (
    <Box>
      <Grid item xs={12} textAlign={'end'} p={1}>
        {!cmd?.is_urgent ? (
          <Button
            variant="contained"
            color="error"
            size="small"
            onClick={(e) => set_show_urg_form(true)}
          >
            Mettre Urgent
          </Button>
        ) : (
          <Button variant="contained" color="error" size="small" onClick={onSetNonUrgent}>
            Mettre Non-Urgent
          </Button>
        )}

        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={(e) => set_show_liv_form(true)}
          sx={{ ml: 1 }}
        >
          Modifier Date Livraison
        </Button>

        <Button
          variant="contained"
          color="success"
          size="small"
          onClick={(e) => set_show_fb_form(true)}
          sx={{ ml: 1 }}
        >
          Changer le fournisseur
        </Button>

        <Button
          variant="contained"
          color="secondary"
          size="small"
          onClick={(e) => set_show_taille_grav_form(true)}
          sx={{ ml: 1 }}
        >
          Modifier taille & gravure
        </Button>
      </Grid>
      {show_urg_form && (
        <Card sx={{ p: 2, borderRadius: 1 }}>
          <Box>
            <Typography variant="h6">Date Urgent :</Typography>
            <TextField
              type="date"
              value={form_urg_values?.date_urgent}
              onChange={(e) => set_form_urg_values({ date_urgent: e?.target?.value })}
            />
            {
              <Box textAlign={'end'}>
                <Button variant="contained" color="success" size="small" onClick={onSetUrgent}>
                  Confirmer
                </Button>
                <Button
                  variant="contained"
                  color="secondary"
                  size="small"
                  onClick={(e) => set_show_urg_form(false)}
                  sx={{ ml: 1 }}
                >
                  Annuler
                </Button>
              </Box>
            }
          </Box>
        </Card>
      )}

      {show_fb_form && (
        <Card sx={{ p: 2, borderRadius: 1 }}>
          <Box>
            <Typography variant="h6">Fournisseur :</Typography>
            <TextField
              select
              fullWidth
              value={form_fb_values}
              onChange={(e) => set_form_fb_values(e?.target?.value)}
            >
              {Array.isArray(lst_fournisseur) &&
                lst_fournisseur.map((el) => (
                  <MenuItem key={`fb-${el?.idFournisseur}`} value={el}>
                    {el?.nomSociete}
                  </MenuItem>
                ))}
            </TextField>
            {
              <Box textAlign={'end'}>
                <Button variant="contained" color="success" size="small" onClick={onSetFournisseur}>
                  Confirmer
                </Button>
                <Button
                  variant="contained"
                  color="secondary"
                  size="small"
                  onClick={(e) => set_show_fb_form(false)}
                  sx={{ ml: 1 }}
                >
                  Annuler
                </Button>
              </Box>
            }
          </Box>
        </Card>
      )}

      {show_liv_form && (
        <Card sx={{ p: 2, borderRadius: 1 }}>
          <Box>
            <Typography variant="h6">Date de livraison :</Typography>
            <TextField
              type="date"
              value={form_liv_values?.date_livraison}
              onChange={(e) => set_form_liv_values({ date_livraison: e?.target?.value })}
            />
            {
              <Box textAlign={'end'}>
                <Button
                  variant="contained"
                  color="success"
                  size="small"
                  onClick={onUpdateDateLivraison}
                >
                  Confirmer
                </Button>
                <Button
                  variant="contained"
                  color="secondary"
                  size="small"
                  onClick={(e) => set_show_liv_form(false)}
                  sx={{ ml: 1 }}
                >
                  Annuler
                </Button>
              </Box>
            }
          </Box>
        </Card>
      )}

      {show_taille_grav_form && (
        <Card sx={{ p: 2, borderRadius: 1 }}>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <Typography variant="h6">Taille :</Typography>
              <TextField
                fullWidth
                size="small"
                type="number"
                value={form_taille_grav_values?.taille}
                onChange={(e) =>
                  set_form_taille_grav_values({
                    ...form_taille_grav_values,
                    taille: e?.target?.value,
                  })
                }
              />
            </Grid>
            <Grid item xs={6}>
              <Typography variant="h6">Gravure :</Typography>
              <TextField
                fullWidth
                size="small"
                type="text"
                value={form_taille_grav_values?.gravure}
                onChange={(e) =>
                  set_form_taille_grav_values({
                    ...form_taille_grav_values,
                    gravure: e?.target?.value,
                  })
                }
              />
            </Grid>
            <Grid item xs={6}>
              <Typography variant="h6">SKU externe :</Typography>
              <TextField
                fullWidth
                size="small"
                type="text"
                value={form_taille_grav_values?.sku_externe}
                onChange={(e) =>
                  set_form_taille_grav_values({
                    ...form_taille_grav_values,
                    sku_externe: e?.target?.value,
                  })
                }
              />
            </Grid>
            <Grid item xs={12}>
              <Box textAlign={'end'}>
                <Button
                  variant="contained"
                  color="success"
                  size="small"
                  onClick={onUpdateTailleGravure}
                >
                  Confirmer
                </Button>
                <Button
                  variant="contained"
                  color="secondary"
                  size="small"
                  onClick={(e) => set_show_taille_grav_form(false)}
                  sx={{ ml: 1 }}
                >
                  Annuler
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Card>
      )}
      {/* --------------------------------------------------------Info------------------------------------ */}
      <Grid item xs={12} sx={{ mt: 2, px: 2, mb: 0 }}>
        <Typography variant="h4" sx={{ mb: 0 }}>
          Info
        </Typography>
      </Grid>
      <Card sx={{ p: 1, borderRadius: 1 }}>
        <CardContent>
          <Grid container spacing={1}>
            <Grid item xs={4} sx={{ mt: 3 }}>
              <Typography variant="h6" color="primary">
                Ref
              </Typography>
              <Typography variant="h6" fontWeight={600}>
                {cmd?.ref || '----'}
              </Typography>
            </Grid>
            <Grid item xs={4} sx={{ mt: 3 }}>
              <Typography variant="h6" color="primary">
                Status
              </Typography>
              {renderStatus(cmd?.status)}
            </Grid>

            <Grid item xs={4} sx={{ mt: 3 }}>
              <Typography variant="h6" color="primary">
                Type
              </Typography>
              <Chip
                sx={{
                  backgroundColor:
                    cmd?.type_commande === true
                      ? (theme) => theme.palette.success.light
                      : (theme) => theme.palette.warning.main,
                  color: '#000',
                  borderRadius: '6px',
                  pl: '3px',
                  pr: '3px',
                }}
                size="small"
                label={cmd?.type_commande}
              />
            </Grid>

            <Grid item xs={4} sx={{ mt: 3 }}>
              <Typography variant="h6" color="primary">
                Fournisseur
              </Typography>
              <Chip
                label={cmd?.fournisseur?.nomSociete || 'Aucun !'}
                sx={{
                  borderRadius: 1,
                  backgroundColor: cmd?.fournisseur?.bg_color ? cmd?.fournisseur?.bg_color : 'gray',
                  color: '#fff',
                }}
                size="small"
              />
            </Grid>

            <Grid item xs={4} sx={{ mt: 3 }}>
              <Typography variant="h6" color="primary">
                Client
              </Typography>
              <Typography variant="h6" fontWeight={600}>
                {cmd?.client ? `${cmd?.client?.nom} ${cmd?.client?.prenom}` : '---'}
              </Typography>
            </Grid>

            <Grid item xs={4} sx={{ mt: 3, pl: 2 }}>
              <Typography variant="h6" color="primary">
                Urgent
              </Typography>
              <Chip
                sx={{
                  backgroundColor:
                    cmd?.is_urgent === true
                      ? (theme) => theme.palette.success.light
                      : (theme) => theme.palette.error.light,
                  color:
                    cmd?.is_urgent === true
                      ? (theme) => theme.palette.success.main
                      : (theme) => theme.palette.error.main,
                  borderRadius: '6px',
                  pl: '3px',
                  pr: '3px',
                }}
                size="small"
                label={cmd?.is_urgent ? `Oui` : 'Non'}
              />
            </Grid>
            <Grid item xs={4} sx={{ mt: 3, pl: 2 }}>
              <Typography variant="h6" color="primary">
                Groupé
              </Typography>
              <Chip
                sx={{
                  backgroundColor:
                    cmd?.is_groupe === true
                      ? (theme) => theme.palette.success.light
                      : (theme) => theme.palette.error.light,
                  color:
                    cmd?.is_groupe === true
                      ? (theme) => theme.palette.success.main
                      : (theme) => theme.palette.error.main,
                  borderRadius: '6px',
                  pl: '3px',
                  pr: '3px',
                }}
                size="small"
                label={cmd?.is_groupe ? 'Oui' : 'Non'}
              />
            </Grid>

            <Grid item xs={4} sx={{ mt: 3 }}>
              <Typography variant="h6" color="primary">
                Date de création
              </Typography>
              <Typography variant="h6" fontWeight={600}>
                {cmd?.created_at ? String(cmd?.created_at).slice(0, 10) : '----'}
              </Typography>
            </Grid>

            <Grid item xs={4} sx={{ mt: 3 }}>
              <Typography variant="h6" color="primary">
                Date livraison prévu
              </Typography>
              <Typography variant="h6" fontWeight={600}>
                {cmd?.date_livraison_prevu
                  ? String(cmd?.date_livraison_prevu).slice(0, 10)
                  : '----'}
              </Typography>
            </Grid>

            <Grid item xs={4} sx={{ mt: 3 }}>
              <Typography variant="h6" color="primary">
                Date livraison
              </Typography>
              <Typography variant="h6" fontWeight={600}>
                {cmd?.date_livraison ? String(cmd?.date_livraison).slice(0, 10) : '----'}
              </Typography>
            </Grid>

            <Grid item xs={4} sx={{ mt: 3 }}>
              <Typography variant="h6" color="primary">
                Date urgent
              </Typography>
              <Typography variant="h6" fontWeight={600}>
                {cmd?.is_urgent ? String(cmd?.date_urgent).slice(0, 10) : '----'}
              </Typography>
            </Grid>

            <Grid item xs={4} sx={{ mt: 3 }}>
              <Typography variant="h6" color="primary">
                Magasin
              </Typography>
              <Typography variant="h6" fontWeight={600}>
                {cmd?.magasin?.code || 'central'}
              </Typography>
            </Grid>

            <Grid item xs={12} sx={{ mt: 3 }}>
              <Typography variant="h6" color="primary">
                Description :
              </Typography>
              <Typography variant="h6" fontWeight={600}>
                {cmd?.description || '---'}
              </Typography>
            </Grid>

            {cmd?.catalogue?.is_sur_mesure && (
              <Grid item xs={12} sx={{ mt: 3 }}>
                <Typography variant="h6" color="primary">
                  Description sur mesure :
                </Typography>
                <Typography variant="h6" fontWeight={600}>
                  {cmd?.description_sur_mesure || cmd?.description || '---'}
                </Typography>
              </Grid>
            )}

            <Grid item xs={12} sx={{ mt: 3 }}>
              <Typography variant="h6" color="primary">
                SKU externe :
              </Typography>
              <Typography variant="h6" fontWeight={600} color={'secondary.main'}>
                {cmd?.sku_externe || cmd?.sku_externe || '---'}
              </Typography>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      {/* --------------------------------------------------------Article------------------------------------ */}
      <Grid item xs={12} sx={{ mt: 2, px: 2, mb: 0 }}>
        <Typography variant="h4" sx={{ mb: 0 }}>
          Article
        </Typography>
      </Grid>

      <Card sx={{ p: 1, borderRadius: 1 }}>
        <CardContent>
          <Grid container spacing={1}>
            <Grid item xs={2} textAlign={'center'}>
              {/* <img
                src={
                  cmd?.catalogue?.img
                    ? `${api_file_url_catalogue}${cmd?.catalogue?.img}`
                    : DefaultImg
                }
                alt="nm"
                style={{ height: 80 }}
              /> */}
              <ImageZoomer
                imageUrl={
                  cmd?.catalogue?.img
                    ? `${api_file_url_catalogue}${cmd?.catalogue?.img}`
                    : DefaultImg
                }
                style={{ height: 80 }}
              />
            </Grid>
            <Grid item xs={10}>
              <Grid container spacing={1}>
                <Grid item xs={12} textAlign={'start'}>
                  <Typography variant="h4" color={'success.main'} fontWeight={600} pt={1}>
                    {cmd?.catalogue?.nom || '----'}
                    {cmd?.catalogue?.groupe_model?.name
                      ? ` (${cmd?.catalogue?.groupe_model?.name} ${cmd?.catalogue?.groupe_model_var})`
                      : ''}

                    <Chip
                      size="small"
                      variant="outlined"
                      color="success"
                      label={cmd?.catalogue?.sku}
                      sx={{ borderRadius: 1, float: 'right' }}
                    />
                  </Typography>
                </Grid>

                <Grid item xs={4} sx={{ mt: 3, pl: 1 }}>
                  <Typography variant="h6" color="primary">
                    Type métal
                  </Typography>
                  <Typography variant="h6" fontWeight={600}>
                    {cmd?.catalogue?.type_metal &&
                      Array.isArray(metaux) &&
                      `${
                        metaux.find((el) => el?.value == cmd?.catalogue?.type_metal)?.label ||
                        '----'
                      }`}
                  </Typography>
                </Grid>

                <Grid item xs={4} sx={{ mt: 3, pl: 1 }}>
                  <Typography variant="h6" color="primary">
                    Couleur
                  </Typography>
                  <Typography variant="h6" fontWeight={600}>
                    {cmd?.catalogue?.couleur_or || '----'}
                  </Typography>
                </Grid>

                <Grid item xs={4} sx={{ mt: 3, pl: 1 }}>
                  <Typography variant="h6" color="primary">
                    Famille
                  </Typography>
                  <Typography variant="h6" fontWeight={600}>
                    {cmd?.catalogue?.famille || '----'}
                  </Typography>
                </Grid>

                <Grid item xs={4} sx={{ mt: 3, pl: 1 }}>
                  <Typography variant="h6" color="primary">
                    Diamant
                  </Typography>
                  <Chip
                    color={cmd?.catalogue?.is_diamant ? 'success' : 'error'}
                    size="small"
                    label={cmd?.catalogue?.is_diamant ? 'Oui' : 'Non'}
                    sx={{ borderRadius: 1 }}
                  />
                </Grid>

                <Grid item xs={4} sx={{ mt: 3, pl: 1 }}>
                  <Typography variant="h6" color="primary">
                    Modèle suivi
                  </Typography>
                  <Chip
                    color={cmd?.catalogue?.is_modele_suivi ? 'success' : 'error'}
                    size="small"
                    label={cmd?.catalogue?.is_modele_suivi ? 'Oui' : 'Non'}
                    sx={{ borderRadius: 1 }}
                  />
                </Grid>

                <Grid item xs={4} sx={{ mt: 3, pl: 1 }}>
                  <Typography variant="h6" color="primary">
                    Factice Dispo
                  </Typography>
                  <Chip
                    color={cmd?.catalogue?.is_factrice_dispo ? 'success' : 'error'}
                    size="small"
                    label={cmd?.catalogue?.is_factrice_dispo ? 'Oui' : 'Non'}
                    sx={{ borderRadius: 1 }}
                  />
                </Grid>

                <Grid item xs={4} sx={{ mt: 3 }}>
                  <Typography variant="h6" color="primary">
                    Groupe modéles
                  </Typography>
                  <Typography variant="h6" fontWeight={600} color={'success.main'}>
                    {cmd?.catalogue?.groupe_model
                      ? `${cmd?.catalogue?.groupe_model?.name} ${cmd?.catalogue?.groupe_model_var}/${cmd?.catalogue?.groupe_model?.nbr_var}`
                      : '----'}
                  </Typography>
                </Grid>

                <Grid item xs={4} sx={{ mt: 3, pl: 1 }}>
                  <Typography variant="h6" color="primary">
                    Delais de fabrication
                  </Typography>
                  <Typography variant="h6" fontWeight={600}>
                    {cmd?.catalogue?.delais_livraison || '----'}
                  </Typography>
                </Grid>

                <Grid item xs={12} sx={{ mt: 3 }}>
                  <Typography variant="h6" color="primary">
                    Caractéristique
                  </Typography>
                  <Typography variant="h6" fontWeight={400}>
                    {cmd?.catalogue?.caracteristique || '----'}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={4} px={1}>
              <Box sx={{ mt: 3, border: '#00c29240 1px solid', background: '#20232a', p: 1 }}>
                <Typography variant="h6" color="primary">
                  Taille
                </Typography>
                <Typography variant="h6" fontWeight={600}>
                  {cmd?.taille || '----'}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={4} px={1}>
              <Box sx={{ mt: 3, border: '#00c29240 1px solid', background: '#20232a', p: 1 }}>
                <Typography variant="h6" color="primary">
                  Gravure
                </Typography>
                <Typography variant="h6" fontWeight={600}>
                  {cmd?.gravure || '----'}
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={4} px={1}>
              <Box sx={{ mt: 3, border: '#00c29240 1px solid', background: '#20232a', p: 1 }}>
                <Typography variant="h6" color="primary">
                  Prix TTC
                </Typography>
                <Typography variant="h6" fontWeight={600} color={'success.main'}>
                  {cmd?.catalogue?.prix_vente_ttc || '----'} €
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      {/* --------------------------------------------------------Document Client------------------------------------ */}
      {cmd?.document_client && (
        <>
          <Grid item xs={12} sx={{ mt: 2, px: 2, mb: 0 }}>
            <Typography variant="h4" sx={{ mb: 0 }}>
              Vente
            </Typography>
          </Grid>

          <Card sx={{ p: 1, borderRadius: 1 }}>
            <CardContent>
              <Grid container spacing={1}>
                <Grid item xs={3} sx={{ mt: 3 }}>
                  <Typography variant="h6" color="primary">
                    Doc Client
                  </Typography>
                  <Link
                    to={`/app/caisse/doc-client/${cmd?.document_client?.idDoc}`}
                    target="_blank"
                  >
                    <Typography variant="h6" fontWeight={600} color={'success.main'}>
                      {cmd?.document_client?.num || '----'}
                    </Typography>
                  </Link>
                </Grid>
                <Grid item xs={3} sx={{ mt: 3 }}>
                  <Typography variant="h6" color="primary">
                    Client
                  </Typography>
                  <Typography variant="h6" fontWeight={600}>
                    {cmd?.document_client?.client
                      ? `${cmd?.document_client?.client?.nom} ${cmd?.document_client?.client?.prenom}`
                      : '----'}
                  </Typography>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </>
      )}

      {/* --------------------------------------------------------Stock------------------------------------ */}
      <Grid item xs={12} sx={{ mt: 2, px: 2, mb: 0 }}>
        <Typography variant="h4" sx={{ mb: 0 }}>
          Stock Liée
        </Typography>
      </Grid>

      <Card sx={{ p: 1, borderRadius: 1 }}>
        <CardContent>
          <Table stickyHeader>
            <TableHead sx={{ borderTop: '1px solid rgba(224, 224, 224, 1)' }}>
              <TableRow>
                <TableCell padding="none" sx={{ textAlign: 'center', py: 1 }}>
                  <Typography variant="subtitle2" fontWeight={500}>
                    Num Inventaire
                  </Typography>
                </TableCell>
                <TableCell padding="none" sx={{ textAlign: 'center', py: 1 }}>
                  <Typography variant="subtitle2" fontWeight={500}>
                    Status
                  </Typography>
                </TableCell>
                <TableCell padding="none" sx={{ textAlign: 'center', py: 1 }}>
                  <Typography variant="subtitle2" fontWeight={500}>
                    Magasin
                  </Typography>
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {cmd?.stock && (
                <TableRow>
                  <TableCell sx={{ textAlign: 'center' }}>
                    <Typography variant="subtitle2" fontWeight={600}>
                      {cmd?.stock?.code_inventaire}
                    </Typography>
                  </TableCell>
                  <TableCell sx={{ textAlign: 'center' }}>
                    <Chip
                      sx={{
                        borderRadius: '6px',
                        pl: '3px',
                        pr: '3px',
                      }}
                      size="small"
                      label={cmd?.stock?.status}
                    />
                  </TableCell>
                  <TableCell sx={{ textAlign: 'center' }}>
                    <Typography variant="subtitle2" fontWeight={600}>
                      {cmd?.stock?.magasin?.code}
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
      {/* --------------------------------------------------------Photos------------------------------------ */}
      <Grid item xs={12} sx={{ mt: 2, px: 2, mb: 0 }}>
        <Typography variant="h4" sx={{ mb: 0 }}>
          Photo joint
        </Typography>
      </Grid>

      <Card sx={{ p: 1, borderRadius: 1 }}>
        <CardContent>
          <Grid container spacing={1}>
            {cmd?.photo_1 && (
              <Grid item xs={3}>
                {/* <img src={`${api_file_url_cmd_fb}${cmd?.photo_1}`} width={'50%'} alt="" /> */}
                <ImageZoomer
                  imageUrl={cmd?.photo_1 ? `${api_file_url_cmd_fb}${cmd?.photo_1}` : DefaultImg}
                  style={{ height: 80 }}
                />
              </Grid>
            )}
            {cmd?.photo_2 && (
              <Grid item xs={3}>
                {/* <img src={`${api_file_url_cmd_fb}${cmd?.photo_2}`} width={'50%'} alt="" /> */}
                <ImageZoomer
                  imageUrl={cmd?.photo_2 ? `${api_file_url_cmd_fb}${cmd?.photo_2}` : DefaultImg}
                  style={{ height: 80 }}
                />
              </Grid>
            )}
            {cmd?.photo_3 && (
              <Grid item xs={3}>
                {/* <img src={`${api_file_url_cmd_fb}${cmd?.photo_3}`} width={'50%'} alt="" /> */}
                <ImageZoomer
                  imageUrl={cmd?.photo_3 ? `${api_file_url_cmd_fb}${cmd?.photo_3}` : DefaultImg}
                  style={{ height: 80 }}
                />
              </Grid>
            )}
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
};

const CmdHistoriqueSection = ({ cmd }) => {
  return (
    <Table stickyHeader>
      <TableHead sx={{ borderTop: '1px solid rgba(224, 224, 224, 1)' }}>
        <TableRow>
          <TableCell padding="none" sx={{ textAlign: 'center', minWidth: 200 }}>
            <Typography variant="subtitle2" fontWeight={500}>
              Activité
            </Typography>
          </TableCell>
          <TableCell padding="none" sx={{ textAlign: 'center', minWidth: 200 }}>
            <Typography variant="subtitle2" fontWeight={500}>
              Fait par
            </Typography>
          </TableCell>
          <TableCell padding="none" sx={{ textAlign: 'center', minWidth: 200 }}>
            <Typography variant="subtitle2" fontWeight={500}>
              Date
            </Typography>
          </TableCell>
        </TableRow>
      </TableHead>
    </Table>
  );
};

const CmdBlocageSection = ({ cmd, onUpdateValues }) => {
  const [show_form, set_show_form] = useState(false);
  const [lst_blocage, set_lst_blocage] = useState([]);

  const [sel_type, set_sel_type] = useState('autre');
  const [sel_note, set_sel_note] = useState(null);

  const onSubmitBlocage = () => {
    if (Array.isArray(lst_blocage)) {
      let tmp = {
        idCmdFournisseur: cmd?.idCmdFournisseur,
        bloquages: [
          ...lst_blocage,
          {
            id: lst_blocage.length + 1,
            type: sel_type,
            note: sel_note,
            date: new Date(),
            user: 'super admin',
            status: 'non-resolus',
          },
        ],
      };
      onUpdateValues(tmp);
      onCloseForm();
    }
  };

  const onResolveBlocage = (id) => {
    if (Array.isArray(lst_blocage)) {
      let tmp = lst_blocage.map((el) => (el?.id == id ? { ...el, status: 'resolus' } : el));
      onUpdateValues({ idCmdFournisseur: cmd?.idCmdFournisseur, bloquages: tmp });
      onCloseForm();
    }
  };

  const onCloseForm = () => {
    set_sel_note(null);
    set_sel_type('autre');
    set_show_form(false);
  };

  useEffect(() => {
    if (Array.isArray(cmd?.bloquages)) set_lst_blocage(cmd?.bloquages);
  }, [cmd]);

  return (
    <Box>
      {!show_form ? (
        <Box textAlign={'end'} py={1}>
          <Button
            variant="contained"
            color="error"
            size="small"
            onClick={(e) => set_show_form(true)}
          >
            Notifier un blocage
          </Button>
        </Box>
      ) : (
        <Box p={0} mb={1}>
          <Card sx={{ p: 1, borderRadius: 1, m: 0 }}>
            <CardContent>
              <Grid container spacing={1}>
                <Grid item xs={12} textAlign={'start'}>
                  <Typography variant="h4" color="primary.main">
                    {'Nouveau blocage'}
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="h6" color="">
                    {'Type de blocage'}
                  </Typography>
                  <TextField
                    fullWidth
                    size="small"
                    select
                    label=""
                    helperText=""
                    value={sel_type}
                    onChange={(e) => set_sel_type(e?.target?.value)}
                  >
                    <MenuItem value={'autre'}> Autre </MenuItem>
                    <MenuItem value={'fourniture'}> fourniture </MenuItem>
                    <MenuItem value={'modele'}> modele </MenuItem>
                  </TextField>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="h6" color="">
                    {'Note de blocage'}
                  </Typography>
                  <TextField
                    fullWidth
                    multiline
                    rows={3}
                    size="small"
                    value={sel_note}
                    onChange={(e) => set_sel_note(e?.target?.value)}
                  />
                </Grid>
                <Grid item xs={12} textAlign={'end'}>
                  <Button
                    variant="contained"
                    color="secondary"
                    size="small"
                    onClick={onCloseForm}
                    sx={{ mr: 1 }}
                  >
                    Annuler
                  </Button>
                  <Button
                    variant="contained"
                    color="success"
                    size="small"
                    onClick={onSubmitBlocage}
                  >
                    Confirmer
                  </Button>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Box>
      )}
      <Table stickyHeader>
        <TableHead sx={{ borderTop: '1px solid rgba(224, 224, 224, 1)' }}>
          <TableRow>
            <TableCell padding="none" sx={{ textAlign: 'center', py: 1 }}>
              <Typography variant="subtitle2" fontWeight={500}>
                Type
              </Typography>
            </TableCell>
            <TableCell padding="none" sx={{ textAlign: 'center', minWidth: 200, py: 1 }}>
              <Typography variant="subtitle2" fontWeight={500}>
                Note
              </Typography>
            </TableCell>
            <TableCell padding="none" sx={{ textAlign: 'center', py: 1 }}>
              <Typography variant="subtitle2" fontWeight={500}>
                Status
              </Typography>
            </TableCell>
            <TableCell padding="none" sx={{ textAlign: 'center', py: 1 }}>
              <Typography variant="subtitle2" fontWeight={500}>
                Date
              </Typography>
            </TableCell>
            <TableCell padding="none" sx={{ textAlign: 'center', py: 1 }}>
              <Typography variant="subtitle2" fontWeight={500}>
                Action
              </Typography>
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {Array.isArray(lst_blocage) &&
            lst_blocage.map((el) => (
              <TableRow>
                <TableCell sx={{ textAlign: 'center' }}>
                  <Chip
                    sx={{
                      backgroundColor:
                        el?.type === 'fourniture'
                          ? (theme) => theme.palette.error.light
                          : el?.type === 'modele'
                            ? (theme) => theme.palette.warning.light
                            : (theme) => theme.palette.secondary.light,
                      color:
                        el?.type === 'fourniture'
                          ? (theme) => theme.palette.error.main
                          : el?.type === 'modele'
                            ? (theme) => theme.palette.warning.main
                            : (theme) => theme.palette.secondary.main,
                      borderRadius: '6px',
                      pl: '3px',
                      pr: '3px',
                    }}
                    size="small"
                    label={el?.type}
                  />
                </TableCell>
                <TableCell sx={{ textAlign: 'center' }}>
                  <Typography variant="subtitle2" fontWeight={500}>
                    {el?.note}
                  </Typography>
                </TableCell>
                <TableCell sx={{ textAlign: 'center' }}>
                  <Chip
                    sx={{
                      backgroundColor:
                        el?.status === 'resolus'
                          ? (theme) => theme.palette.success.main
                          : (theme) => theme.palette.error.main,
                      color: '#fff',
                      borderRadius: '6px',
                      pl: '3px',
                      pr: '3px',
                    }}
                    size="small"
                    label={el?.status}
                  />
                </TableCell>
                <TableCell sx={{ textAlign: 'center' }}>
                  <Typography variant="subtitle2" fontWeight={500}>
                    {String(el?.date).slice(0, 10)}
                  </Typography>
                </TableCell>
                <TableCell sx={{ textAlign: 'center' }}>
                  {el?.status != 'resolus' && (
                    <Button
                      sx={{ py: '0px' }}
                      variant="contained"
                      color="success"
                      size="small"
                      onClick={(e) => onResolveBlocage(el?.id)}
                    >
                      Résolus
                    </Button>
                  )}
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </Box>
  );
};

const CmdNoteSection = ({ cmd, onUpdateValues }) => {
  const [show_form, set_show_form] = useState(false);
  const [lst_note, set_lst_note] = useState([]);

  const [sel_type, set_sel_type] = useState('');
  const [sel_note, set_sel_note] = useState(null);

  const onSubmitBlocage = () => {
    if (Array.isArray(lst_note)) {
      let tmp = {
        idCmdFournisseur: cmd?.idCmdFournisseur,
        notes: [
          ...lst_note,
          {
            id: lst_note.length + 1,
            title: sel_type,
            description: sel_note,
            date: new Date(),
            user: 'super admin',
          },
        ],
      };
      onUpdateValues(tmp);
      onCloseForm();
    }
  };

  const onCloseForm = () => {
    set_sel_note('');
    set_sel_type('');
    set_show_form(false);
  };

  useEffect(() => {
    if (Array.isArray(cmd?.notes)) set_lst_note(cmd?.notes);
  }, [cmd]);

  return (
    <Box>
      {!show_form ? (
        <Box textAlign={'end'} py={1}>
          <Button
            variant="contained"
            color="success"
            size="small"
            onClick={(e) => set_show_form(true)}
          >
            Ajouter une note
          </Button>
        </Box>
      ) : (
        <Box p={0} mb={1}>
          <Card sx={{ p: 1, borderRadius: 1, m: 0 }}>
            <CardContent>
              <Grid container spacing={1}>
                <Grid item xs={12} textAlign={'start'}>
                  <Typography variant="h4" color="primary.main">
                    {'Nouvelle Note'}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="h6" color="">
                    {'Titre'}
                  </Typography>
                  <TextField
                    fullWidth
                    size="small"
                    label=""
                    helperText=""
                    value={sel_type}
                    onChange={(e) => set_sel_type(e?.target?.value)}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="h6" color="">
                    {'Description'}
                  </Typography>
                  <TextField
                    fullWidth
                    multiline
                    rows={3}
                    size="small"
                    value={sel_note}
                    onChange={(e) => set_sel_note(e?.target?.value)}
                  />
                </Grid>
                <Grid item xs={12} textAlign={'end'}>
                  <Button
                    variant="contained"
                    color="secondary"
                    size="small"
                    onClick={onCloseForm}
                    sx={{ mr: 1 }}
                  >
                    Annuler
                  </Button>
                  <Button
                    variant="contained"
                    color="success"
                    size="small"
                    onClick={onSubmitBlocage}
                  >
                    Confirmer
                  </Button>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Box>
      )}

      {Array.isArray(lst_note) &&
        lst_note?.map((el) => (
          <Card sx={{ borderRadius: 1 }}>
            <Typography variant="subtitle1" color={'primary.main'}>
              {el?.title}{' '}
              <span style={{ float: 'right', color: '#b9b9b9' }}>
                {String(el?.date).substring(0, 10)}
              </span>
            </Typography>
            <Typography variant="subtitle2">{el?.description}</Typography>
          </Card>
        ))}
    </Box>
  );
};

const ControleQualiteSection = ({ cmd }) => {
  return (
    <Grid container spacing={0} py={0}>
      {cmd?.cq ? (
        <Card sx={{ borderRadius: 1, py: 4 }}>
          <Grid item xs={12} container>
            <Grid item xs={6}>
              <Typography variant="h6" color="primary.main">
                Date
              </Typography>
              <Typography variant="h6" fontWeight={500}>
                {cmd?.cq?.created_at ? String(cmd?.cq?.created_at).substring(0, 10) : '----'}
              </Typography>
            </Grid>

            <Grid item xs={6} textAlign={'end'}>
              <Chip
                color={cmd?.cq?.is_valide ? 'success' : 'error'}
                label={cmd?.cq?.is_valide ? 'Validé' : 'Non Validé'}
                sx={{ borderRadius: 1, px: 3 }}
              />
            </Grid>
            <Grid item xs={12} my={2}>
              <Typography variant="h6" color="primary">
                Note du validateur
              </Typography>
              <Typography variant="h6" fontWeight={500}>
                {cmd?.cq?.note || '----'}
              </Typography>
            </Grid>

            <Grid item xs={3} px={1} textAlign={'center'}>
              <Box sx={{ mt: 3, background: '#20232a', p: 0 }}>
                <Box p={1}>
                  <Typography variant="h6" color="primary">
                    Taille
                  </Typography>
                  <Typography variant="h6" fontWeight={600}>
                    {cmd?.cq?.taille || '----'}
                  </Typography>
                </Box>
                <Box
                  sx={{ background: cmd?.cq?.is_taille_valide ? '#0a9371' : '#c34c58', py: '2px' }}
                >
                  <Typography variant="h6" textAlign={'center'}>
                    {cmd?.cq?.is_taille_valide ? 'Valide' : 'Non Valide'}
                  </Typography>
                </Box>
              </Box>
            </Grid>

            <Grid item xs={3} px={1} textAlign={'center'}>
              <Box sx={{ mt: 3, background: '#20232a', p: 0 }}>
                <Box p={1}>
                  <Typography variant="h6" color="primary">
                    Gravure
                  </Typography>
                  <Typography variant="h6" fontWeight={600}>
                    {cmd?.cq?.gravure || '----'}
                  </Typography>
                </Box>
                <Box
                  sx={{ background: cmd?.cq?.is_gravure_valide ? '#0a9371' : '#c34c58', py: '2px' }}
                >
                  <Typography variant="h6" textAlign={'center'}>
                    {cmd?.cq?.is_gravure_valide ? 'Valide' : 'Non Valide'}
                  </Typography>
                </Box>
              </Box>
            </Grid>

            <Grid item xs={3} px={1} textAlign={'center'}>
              <Box sx={{ mt: 3, background: '#20232a', p: 0 }}>
                <Box p={1}>
                  <Typography variant="h6" color="primary">
                    Couleur
                  </Typography>
                  <Typography variant="h6" fontWeight={600}>
                    {cmd?.cq?.couleur || '----'}
                  </Typography>
                </Box>
                <Box
                  sx={{ background: cmd?.cq?.is_couleur_valide ? '#0a9371' : '#c34c58', py: '2px' }}
                >
                  <Typography variant="h6" textAlign={'center'}>
                    {cmd?.cq?.is_couleur_valide ? 'Valide' : 'Non Valide'}
                  </Typography>
                </Box>
              </Box>
            </Grid>

            <Grid item xs={3} px={1} textAlign={'center'}>
              <Box sx={{ mt: 3, background: '#20232a', p: 0 }}>
                <Box p={1}>
                  <Typography variant="h6" color="primary">
                    Métal
                  </Typography>
                  <Typography variant="h6" fontWeight={600}>
                    {metaux?.find((el) => el?.value == cmd?.cq?.metal)?.label || '----'}
                  </Typography>
                </Box>
                <Box
                  sx={{ background: cmd?.cq?.is_metal_valide ? '#0a9371' : '#c34c58', py: '2px' }}
                >
                  <Typography variant="h6" textAlign={'center'}>
                    {cmd?.cq?.is_metal_valide ? 'Valide' : 'Non Valide'}
                  </Typography>
                </Box>
              </Box>
            </Grid>

            <Grid item xs={3} px={1} textAlign={'center'}>
              <Box sx={{ mt: 3, background: '#20232a', p: 0 }}>
                <Box p={1}>
                  <Typography variant="h6" color="primary">
                    Poids CTS
                  </Typography>
                  <Typography variant="h6" fontWeight={600}>
                    {cmd?.cq?.poids_cts || '----'} CTS
                  </Typography>
                </Box>
                <Box
                  sx={{
                    background: cmd?.cq?.is_poids_cts_valide ? '#0a9371' : '#c34c58',
                    py: '2px',
                  }}
                >
                  <Typography variant="h6" textAlign={'center'}>
                    {cmd?.cq?.is_poids_cts_valide ? 'Valide' : 'Non Valide'}
                  </Typography>
                </Box>
              </Box>
            </Grid>

            <Grid item xs={3} px={1} textAlign={'center'}>
              <Box sx={{ mt: 3, background: '#20232a', p: 0 }}>
                <Box p={1}>
                  <Typography variant="h6" color="primary">
                    PC
                  </Typography>
                  <Typography variant="h6" fontWeight={600}>
                    {cmd?.cq?.pc || '----'} CTS
                  </Typography>
                </Box>
                <Box sx={{ background: cmd?.cq?.is_pc_valide ? '#0a9371' : '#c34c58', py: '2px' }}>
                  <Typography variant="h6" textAlign={'center'}>
                    {cmd?.cq?.is_pc_valide ? 'Valide' : 'Non Valide'}
                  </Typography>
                </Box>
              </Box>
            </Grid>

            <Grid item xs={3} px={1} textAlign={'center'}>
              <Box sx={{ mt: 3, background: '#20232a', p: 0 }}>
                <Box p={1}>
                  <Typography variant="h6" color="primary">
                    PPVG
                  </Typography>
                  <Typography variant="h6" fontWeight={600}>
                    {cmd?.cq?.pv || '----'} CTS
                  </Typography>
                </Box>
                <Box sx={{ background: cmd?.cq?.is_pv_valide ? '#0a9371' : '#c34c58', py: '2px' }}>
                  <Typography variant="h6" textAlign={'center'}>
                    {cmd?.cq?.is_pv_valide ? 'Valide' : 'Non Valide'}
                  </Typography>
                </Box>
              </Box>
            </Grid>

            <Grid item xs={3} px={1} textAlign={'center'}>
              <Box sx={{ mt: 3, background: '#20232a', p: 0 }}>
                <Box p={1}>
                  <Typography variant="h6" color="primary">
                    Poids GR
                  </Typography>
                  <Typography variant="h6" fontWeight={600}>
                    {cmd?.cq?.poids_cts || '----'} CTS
                  </Typography>
                </Box>
                <Box
                  sx={{
                    background: cmd?.cq?.is_poids_cts_valide ? '#0a9371' : '#c34c58',
                    py: '2px',
                  }}
                >
                  <Typography variant="h6" textAlign={'center'}>
                    {cmd?.cq?.is_poids_cts_valide ? 'Valide' : 'Non Valide'}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Card>
      ) : (
        <>
          <Grid item xs={12} py={3}>
            <Alert variant="outlined" severity="warning">
              Aucun contrôle qualité n'a été effectué pour cette commande!
            </Alert>
          </Grid>
        </>
      )}
    </Grid>
  );
};
export default CmdFbDetailsWidget;
